
import { Component, Vue, Prop } from "vue-property-decorator";
import { Task, TaskInterface } from "@/store/modules";

@Component
export default class ServiceTypeBadge extends Vue {
  @Prop(Task)
  private record!: TaskInterface;

  text() {
    if (this.record.hvac_flag === 1 && this.record.plumbing_flag === 1) {
      return "HVAC + Plumbing";
    } else if (this.record.hvac_flag === 1) {
      return "HVAC";
    } else if (this.record.plumbing_flag === 1) {
      return "Plumbing";
    } else {
      return "General";
    }
  }

  color() {
    if (this.record.hvac_flag === 1 && this.record.plumbing_flag === 1) {
      return "#ff8c00"; // Orange
    } else if (this.record.hvac_flag === 1) {
      return "#aa26ff"; // Purple
    } else if (this.record.plumbing_flag === 1) {
      return "#1e90ff"; // Blue
    } else {
      return "#32a852"; // Green
    }
  }
}
